import React from 'react'
import Preview from '../../../Shared/components/preview/Preview'

const PreviewPage: React.FunctionComponent = () => {
  return <Preview mode="preview" />
}

const Previews = () => (
  <PreviewPage />
)

export default Previews